<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="class-type"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.is_free`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_free"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_free"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
      </datatable>
      </div>
    </div>
    <form-data ref="form" module="class-type" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="class-type"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormData from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Paket", route: "" },
      { title: "Kelas" }
    ]);
  },
  data() {
    return {
      title: "Kelas",
      url: "class-type/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Slug",
          value: "slug",
          sortable: true,
          searchable: true
        },
        {
          text: "Nama Kelas",
          value: "name",
          sortable: true,
          searchable: true
        },
        {
          text: "Gratis",
          value: "is_free",
          sortable: true,
          searchable: false
        },
        {
          text: "Free Kuota",
          value: "free_quota",
          sortable: true,
          searchable: false
        },
        
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormData
  }
};
</script>
